<template>
  <div class="dashboard-widget-content">
    <template v-if="!value.ShowOptions">
      <div class="text-success widget-text-row" v-if="isAllActive && items.length > 0"><b>{{ $t('widget.WCSActivity.status.active') }}</b></div>
      <template v-if="!isAllActive">
        <div class="text-danger widget-text-row"><b>{{ $t('widget.WCSActivity.status.inactive') }}</b></div>
        <div class="text-danger widget-text-row" v-for="(item, index) in inactiveItems" :key="index">
          {{ item.name }} ({{ item.server }})
        </div>
      </template>
    </template>

    <template v-else>
      <widget-options>
        <md-field>
          <label>{{ $t('widget.options.update') }}</label>
          <md-select v-model="options.update">
            <md-option value="1">1 {{ $t('widget.options.min') }}</md-option>
            <md-option value="10">10 {{ $t('widget.options.min') }}</md-option>
            <md-option value="0">{{ $t('widget.options.no') }}</md-option>
          </md-select>
        </md-field>
      </widget-options>
    </template>
  </div>
</template>

<script>
import {WCSActivity} from "@/services/Widgets";
import widgetMixin from './mixin'
export default {
  mixins:[widgetMixin],
  name: "WCSActivity",
  props:{
    value: {}
  },
  data(){return{
    options:{
      update: '1',
    },
    items: [],
    timer: null
  }},
  computed: {
    isAllActive() {
      return !this.items.some((item) => item.status === 0);
    },
    inactiveItems() {
      return this.items.filter((item) => item.status === 0);
    }
  },
  methods:{
    title(){
      const $t = this.$t.bind(this);
      let title = $t(`widget.${this.value.name}.title`);
      return title;
    },
    async getWCSData() {
      const response = await WCSActivity();
      if (response.data) {
        this.items = response.data;
      }
    },
    intervalFunc() {
      clearInterval(this.timer);
      const interval = (1000 * 60 * parseInt(this.options.update)) || 0;
      if (interval > 0) {
        this.timer = setInterval(() => {
          this.getWCSData();
        }, interval);
      }
    }
  },
  watch: {
    'options.update'() {
      this.intervalFunc();
    }
  },
  mounted() {
    this.getWCSData();
    this.intervalFunc();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
</script>
